import { render, staticRenderFns } from "./DadosPrincipais.vue?vue&type=template&id=237414a6"
import script from "./DadosPrincipais.vue?vue&type=script&lang=js"
export * from "./DadosPrincipais.vue?vue&type=script&lang=js"
import style0 from "./DadosPrincipais.vue?vue&type=style&index=0&id=237414a6&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports